module.exports = __webpack_public_path__ + "sort-dwn.png?e11920af57eae2ca87dcd00571f0b895";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/sort-dwn.png
// module id = 470
// module chunks = 0